export const CLEARABLES_PAGE_SIZE = 100;
export const graphqlNull = null as unknown as undefined;
